import { render, staticRenderFns } from "./MyInsurancesZakelijk.vue?vue&type=template&id=3aea4db2"
import script from "./MyInsurancesZakelijk.vue?vue&type=script&lang=js"
export * from "./MyInsurancesZakelijk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports